// 对认证路由的一层薄封装。所有调用都通过共享的
// `http()` 实例发出，这样 CSRF 与 cookie 行为可以统一处理。
import { http } from '../runtime/http';
import type { SessionUser } from '../store/sessionStore';

interface AuthBody {
  user: SessionUser;
  csrf_token: string;
}

export async function readSession(): Promise<AuthBody | null> {
  try {
    const { data } = await http().get<AuthBody>('/auth/session');
    return data;
  } catch (err: unknown) {
    // 401 表示“当前没有有效 session”，返回 null 让壳层自行路由回
    // /login；其它状态继续向上抛出。
    const status =
      typeof err === 'object' && err !== null && 'response' in err
        ? (err as { response?: { status?: number } }).response?.status
        : undefined;
    if (status === 401) return null;
    throw err;
  }
}

export async function logout(): Promise<string | null> {
  const res = await http().post('/auth/logout');
  // 后端对接 blade-oauth 时返回 { logout_url }，mock 模式返回 204 无 body
  return res.data?.logout_url || null;
}
